export const animationOptionsMap = {
  "None": "none",
  "Fade In": "fade-in",
  "Drop": "drop",
  "Fly In Bottom": "fly-in-bottom",
  "Fly In Top": "fly-in-top",
  "Fly In Left": "fly-in-left",
  "Fly In Right": "fly-in-right",
  "Pulse": "pulse",
  "Scale Fade Down": "scale-fade-down",
  "Scale Fade Up": "scale-fade-up",
  "Rotate In Left": "rotate-in-left",
  "Rotate In Right": "rotate-in-right",
  "Zoom In": "zoom-in",
  "Zoom Out": "zoomn-out",
  "Pan Down": "pan-down",
  "Pan Up": "pan-up",
  "Pan Left": "pan-left",
  "Pan Right": "pan-right",
  "Whoosh In Left": "whoosh-in-left",
  "Whoosh In Right": "whoosh-in-right",
  "Twirl In": "twirl-in"
};